<template>
  <!-- 翠麟点映 -->
  <div class="Showing bg-round bg-fff">
    <div class="main-img ">
      <el-carousel height="100%">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <div class="width100">
            <img
              :src="item.Image"
              alt=""
              srcset=""
              width="100%"
              height="100%"
              class="img_cover"
            />
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div>
      <div class="container">
        <Bread :list="breadList" class="ma-t-10" />
        <div>
          <div class="flex f-jcenter b-b-1-e3 t-center">
            <div
              class="ma-r-20 pa-tb-20 c-p"
              :class="{ 'tab-active': tabActive == 0 }"
              @click="
                tabActive = 0;
                loadDataList('refresh');
              "
            >
              展映基地
            </div>
            <div
              class="ma-l-20 pa-tb-20 c-p"
              :class="{ 'tab-active': tabActive == 1 }"
              @click="
                tabActive = 1;
                loadDataList('refresh');
              "
            >
              展映活动
            </div>
            <div
              class="ma-l-20 pa-tb-20 c-p"
              @click="$router.push({path:'/vod/index'})"
            >
              云展映
            </div>
          </div>

          <div v-if="tabActive == 0">
            <div class="flex f-wrap f-between ma-t-30">
              <div
                class="width48 ma-b-40"
                v-for="(item, index) in dataList"
                :key="index"
              >
                <el-carousel height="350">
                  <el-carousel-item
                    v-for="(src, index0) in item.Images"
                    :key="index0"
                  >
                    <div class="width100">
                      <img
                        :src="src"
                        alt=""
                        srcset=""
                        width="100%"
                        height="100%"
                        class="img_cover"
                      />
                    </div>
                  </el-carousel-item>
                </el-carousel>
                <div class="pa-10">
                  <div class="t-omit-1 font-bold">{{ item.Name }}</div>
                  <div class="t-omit-3 ma-t-10">{{ item.Summary }}</div>
                  <div class="flex f-between f-center ma-t-10">
                    <div>
                      <i class="el-icon-location-outline"></i>
                      {{ item.Address }}
                    </div>
                    <div
                      class="btn-detail c-p"
                      @click="
                        $router.push({
                          path: '/showing/site/detail',
                          query: { id: item.Id },
                        })
                      "
                    >
                      详细介绍
                    </div>
                  </div>
                  <div v-if="item.IsActivity">
                    <div
                      v-for="(item2, index2) in item.Activity"
                      :key="index2"
                      class="flex f-between b-r-30 b-1-red pa-10 c-red ma-t-10 c-p"
                      @click="
                        $router.push({
                          path: '/showing/activity/detail',
                          query: { id: item2.Id,siteId:item.Id },
                        })
                      "
                    >
                      <div class="">
                        {{ item2.Name }}
                      </div>
                      <div class="font-bold">进行中</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="tabActive == 1">
            <div class="ma-t-30" v-for="(item, index) in dataList" :key="index">
              <div class="flex">
                <img
                  :src="item.Image"
                  alt=""
                  srcset=""
                  width="380"
                  height="260"
                  class="img_cover b-r-15"
                />
                <div
                  class="flex1 flex flex-direction pa-tb-10 f-between ma-l-20"
                >
                  <div class="flex f-between">
                    <div class="fon-20 t-omit-1 c-p" :title="item.ActivityName" @click="
                        $router.push({
                          path: '/showing/activity/detail',
                          query: { id: item.ActivityId,siteId:item.SiteId },
                        })
                      ">
                      {{ item.ActivityName }}
                    </div>
                    <div class="c-red font-bold fon-22">￥{{ item.Price }}</div>
                  </div>
                  <div class="t-omit-2">
                    {{ item.Summary }}
                  </div>
                  <div>
                    <i class="el-icon-time"></i>
                    {{ item.StartTime }} - {{ item.EndTime }}
                  </div>
                  <div>
                    <i class="el-icon-location-outline"></i>
                    {{ item.Address }}
                  </div>
                  <div class="flex f-between">
                    <div>
                      <i class="el-icon-phone-outline"></i>
                      {{ item.Phone }} {{ item.Contact }}
                    </div>
                    <div
                      class="btn-detail c-p"
                      @click="
                        $router.push({
                          path: '/showing/activity/detail',
                          query: { id: item.ActivityId,siteId:item.SiteId },
                        })
                      "
                    >
                      {{ item.IsBuy ? "已购买" : "在线购买" }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex f-wrap ma-t-30">
                <div
                  class="box-item ma-b-0 t-center c-p"
                  v-for="(item2, index2) in item.MovieList"
                  :key="index2"
                >
                  <img
                    :src="item2.Image"
                    width="100%"
                    height="80%"
                    class="img_cover b-r-15"
                    alt=""
                    srcset=""
                  />
                  <div class="ma-t-20 t-omit-1">{{ item2.Name }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Empty :isShow="!dataList || dataList.length == 0"></Empty>
        <div class="fy t-center">
          <el-pagination
            @current-change="handleCurrentChange"
            :hide-on-single-page="true"
            :current-page.sync="pageIndex"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="totals"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getShowingSiteBanner,
  getShowingSiteList,
  getShowingList
} from "../api.js";
export default {
  data() {
    return {
      breadList: [
        {
          name: "翠麟点映",
          path: "/showing/site/index",
        },
      ],
      totals: 0, //一个分类下的总条数
      pageIndex: 1,
      pageSize: 10,
      dataList: [],
      bannerList: [], //轮播图列表
      tabActive: 0,
    };
  },
  created() {
    this.loadData();
    this.loadDataList();
  },
  methods: {
    // 当前页改变时触发
    handleCurrentChange(e) {
      this.pageIndex = e;
      this.loadDataList();
    },
    //获取数据
    loadData() {
      getShowingSiteBanner().then((res) => {
        this.bannerList = res.data.Data;
      });
    },
    //获取列表
    loadDataList(type) {
      if (type == "refresh") {
        this.pageIndex = 1;
      }
      if (this.tabActive == 0) {
        getShowingSiteList({
          categoryId: this.categoryId,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        }).then((res) => {
          this.dataList = res.data.Data.List;
          this.totals = res.data.Data.TotalCount;
        });
      } else if (this.tabActive == 1) {
        getShowingList({
          categoryId: this.categoryId,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          type:2
        }).then((res) => {
          this.dataList = res.data.Data.List;
          this.totals = res.data.Data.TotalCount;
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.main-img {
  height: calc(
    100vh - 100px
  ); //减去顶部菜单的距离，实现任意屏幕的第一屏仅显示菜单和图片效果
}
.width48 {
  width: 48%;
}
.container {
  min-height: 1150px;
  // background: #ffffff;
  box-sizing: border-box;
  padding: 30px 40px;
}
.box-item {
  width: 18%;
  height: 320px;
}
.box-item:not(:nth-child(5n)) {
  margin-right: calc(10% / 5);
}

.tab-active {
  border-bottom: 3px solid #fb004d;
  font-weight: bold;
}

.btn-detail {
  width: 119px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  background: #fb004d;
  border-radius: 20px;
  color: #fff;
}
.b-1-red {
  border: 1px solid #fb004d;
}
</style>